import React from 'react';
import { Phone, Mail, MapPin, Building2 } from 'lucide-react';
import { branches, company } from '../mock';
import LeadForm from './LeadForm';

export default function Contact() {
  return (
    <section id="contact" className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-primary font-semibold uppercase tracking-wider text-sm">Get In Touch</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-extrabold text-slate-900 font-display">
            Let&rsquo;s Connect &mdash; Your Questions, Our Priority
          </h2>
          <p className="mt-3 text-slate-600">Reach out anytime. Our compliance experts are ready to help.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          {/* Branches */}
          <div className="space-y-5">
            <div className="flex items-center gap-3 mb-2">
              <MapPin className="w-5 h-5 text-primary" />
              <h3 className="text-xl font-bold text-slate-900 font-display">Our Branches</h3>
            </div>
            {branches.map((b) => (
              <div key={b.city} className="bg-slate-50 rounded-2xl border border-slate-100 p-5 flex items-start gap-4 card-hover">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Building2 className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <div className="text-xs font-semibold text-accent uppercase tracking-wider">{b.type}</div>
                  <div className="text-lg font-bold text-slate-900 font-display">{b.city}</div>
                  <div className="mt-1.5 flex flex-col sm:flex-row sm:items-center gap-x-5 gap-y-1 text-sm">
                    <a href={`tel:${b.phone.replace(/[^0-9]/g, '')}`} className="flex items-center gap-2 text-slate-600 hover:text-primary transition-colors">
                      <Phone className="w-4 h-4" /> {b.phone}
                    </a>
                    <a href={`mailto:${b.email}`} className="flex items-center gap-2 text-slate-600 hover:text-primary transition-colors">
                      <Mail className="w-4 h-4" /> {b.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
            <div className="bg-[#0B2447] rounded-2xl p-6 text-white">
              <p className="text-slate-300 text-sm">We&rsquo;ve been waiting for you! Let us know how we can help.</p>
              <div className="mt-3 flex flex-wrap gap-4">
                <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-2 font-semibold text-white hover:text-accent transition-colors">
                  <Phone className="w-4 h-4 text-accent" /> {company.phone}
                </a>
                <a href={`mailto:${company.email}`} className="flex items-center gap-2 font-semibold text-white hover:text-accent transition-colors">
                  <Mail className="w-4 h-4 text-accent" /> {company.email}
                </a>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-7 h-fit">
            <LeadForm title="Send Us a Message" />
          </div>
        </div>
      </div>
    </section>
  );
}
